'use client';

import React, { useState, useEffect, useRef, useCallback } from 'react';


// ─── Types ───────────────────────────────────────────────────────────────────

type Category = 'All' | 'Films' | 'Advertising' | 'Music Bands' | 'Exhibitions';

interface ModalVideo {
  muxId: string;
  label?: string;
}

interface ModalSection {
  title?: string;
  description?: string;
  role?: string;
  videos: ModalVideo[];
  images?: {src: string;alt: string;}[];
  unifiedGrid?: boolean;
}

interface Project {
  title: string;
  year?: string;
  subtitle?: string;
  imgSrc: string;
  imgScale?: number;
  imgFit?: 'cover' | 'contain';
  category: Category[];
  muxIds?: string[];
  localVideos?: string[];
  modalSections?: ModalSection[];
}

// ─── Data ────────────────────────────────────────────────────────────────────

const projects: Project[] = [
{
  title: 'WhatsApp',
  subtitle: 'US',
  imgSrc: '/assets/images/whatsapp-1784076705218.jpg',
  category: ['Advertising'],
  muxIds: ['Lx01XZHTaC8f00ADFUPxhCC9SaahO500fBxvLnfivrVaBQ'],
  modalSections: [
  {
    title: 'WhatsApp',
    description: 'United States',
    role: 'Composed, produced, mixed.',
    videos: [{ muxId: 'Lx01XZHTaC8f00ADFUPxhCC9SaahO500fBxvLnfivrVaBQ' }]
  }]

},
{
  title: 'Mercado Libre',
  subtitle: 'MX',
  imgSrc: '/assets/images/Mercadolibre-1784076548612.png',
  category: ['Advertising'],
  muxIds: ['B1u3Y029eKk602OX2ZaCwjP6fwWtREAFlWBpiRX2MMYU8'],
  modalSections: [
  {
    title: 'Mercado Libre',
    description: 'Mexico',
    role: 'Composed, produced, mixed.',
    videos: [{ muxId: 'B1u3Y029eKk602OX2ZaCwjP6fwWtREAFlWBpiRX2MMYU8' }]
  }]

},
{
  title: 'Dove',
  subtitle: 'US',
  imgSrc: 'https://image.mux.com/Q4aapEhNv6QTC00Cehgsx3HnpFE6Z8UTkBpIX5KaOJzs/thumbnail.webp?time=22',
  category: ['Advertising'],
  muxIds: ['Q4aapEhNv6QTC00Cehgsx3HnpFE6Z8UTkBpIX5KaOJzs'],
  modalSections: [
  {
    title: 'Dove',
    description: 'United States',
    role: 'Composed, produced, mixed.',
    videos: [{ muxId: 'Q4aapEhNv6QTC00Cehgsx3HnpFE6Z8UTkBpIX5KaOJzs' }]
  }]

},
{
  title: 'Skip',
  subtitle: 'AR',
  imgSrc: 'https://image.mux.com/S3o7HZj02QJHlEbIhIClwogqePIPDM7Kf5UkMYpgGGHA/thumbnail.webp?time=2',
  category: ['Advertising'],
  muxIds: ['S3o7HZj02QJHlEbIhIClwogqePIPDM7Kf5UkMYpgGGHA'],
  modalSections: [
  {
    title: 'Skip',
    description: 'Argentina',
    role: 'Composed, produced, mixed.',
    videos: [{ muxId: 'S3o7HZj02QJHlEbIhIClwogqePIPDM7Kf5UkMYpgGGHA' }]
  }]

},
{
  title: 'Tequila Cazadores',
  subtitle: 'MX',
  imgSrc: 'https://image.mux.com/NOqkbMAuIRQ7yKfBQPin9wXxc84wI1HUuIz7eCqaisw/thumbnail.webp?time=2',
  imgScale: 1.25,
  category: ['Advertising'],
  muxIds: ['NOqkbMAuIRQ7yKfBQPin9wXxc84wI1HUuIz7eCqaisw'],
  modalSections: [
  {
    title: 'Tequila Cazadores',
    description: 'Mexico',
    role: 'Composed, produced, mixed.',
    videos: [{ muxId: 'NOqkbMAuIRQ7yKfBQPin9wXxc84wI1HUuIz7eCqaisw' }]
  }]

},
{
  title: 'Movistar',
  subtitle: 'AR',
  imgSrc: '/assets/images/Movistar-1784076548050.png',
  category: ['Advertising'],
  muxIds: ['00zbNatOD01GjENIj00eO01fPyJTJCBUSUzFDYM012Ji2pDU'],
  modalSections: [
  {
    title: 'Movistar',
    description: 'Argentina',
    role: 'Composed, produced, mixed.',
    videos: [{ muxId: '00zbNatOD01GjENIj00eO01fPyJTJCBUSUzFDYM012Ji2pDU' }]
  }]

},
{
  title: 'Personal',
  subtitle: 'AR',
  imgSrc: 'https://image.mux.com/102a5ILN101effj00r7ZLwcWPFsAhbhk7nOsk6RiV7c1kY/thumbnail.webp?time=12',
  category: ['Advertising'],
  muxIds: ['102a5ILN101effj00r7ZLwcWPFsAhbhk7nOsk6RiV7c1kY'],
  modalSections: [
  {
    title: 'Personal',
    description: 'Argentina',
    role: 'Composed, produced, mixed.',
    videos: [{ muxId: '102a5ILN101effj00r7ZLwcWPFsAhbhk7nOsk6RiV7c1kY' }]
  }]

},
{
  title: 'Yukon',
  subtitle: 'CAN',
  imgSrc: 'https://image.mux.com/98bu57HSsbizT024xSlH3sR02IbqIjDt3bwDE01Km97bFI/thumbnail.webp?time=2',
  category: ['Advertising'],
  muxIds: ['98bu57HSsbizT024xSlH3sR02IbqIjDt3bwDE01Km97bFI'],
  modalSections: [
  {
    title: 'Yukon',
    description: 'Canada',
    role: 'Composed, produced, mixed.',
    videos: [{ muxId: '98bu57HSsbizT024xSlH3sR02IbqIjDt3bwDE01Km97bFI' }]
  }]

},
{
  title: 'PedidosYa',
  subtitle: 'AR',
  imgSrc: 'https://image.mux.com/xq15qPKL193FwL9ChNlPE7npEfP6UVLcMTm3J02sOtQs/thumbnail.webp?time=13.6',
  category: ['Advertising'],
  muxIds: ['xq15qPKL193FwL9ChNlPE7npEfP6UVLcMTm3J02sOtQs'],
  modalSections: [
  {
    title: 'PedidosYa',
    description: 'Argentina',
    role: 'Composed, produced, mixed.',
    videos: [{ muxId: 'xq15qPKL193FwL9ChNlPE7npEfP6UVLcMTm3J02sOtQs' }]
  }]

},
{
  title: 'Hinds',
  subtitle: 'AR',
  imgSrc: 'https://image.mux.com/5D02ivY6AZ02tfJHYYBpZwkTlkj1z4tCwtsGp01G1g025XE/thumbnail.webp?time=20',
  category: ['Advertising'],
  muxIds: ['5D02ivY6AZ02tfJHYYBpZwkTlkj1z4tCwtsGp01G1g025XE'],
  modalSections: [
  {
    title: 'Hinds',
    description: 'Argentina',
    role: 'Composed, produced, mixed.',
    videos: [{ muxId: '5D02ivY6AZ02tfJHYYBpZwkTlkj1z4tCwtsGp01G1g025XE' }]
  }]

},
{
  title: 'Vat 69',
  subtitle: 'AR',
  imgSrc: 'https://image.mux.com/bwp00SHIXyUrTWuMiHfNcNXKYuWxaQVOl24UlzF2r3024/thumbnail.webp?time=7',
  category: ['Advertising'],
  muxIds: ['bwp00SHIXyUrTWuMiHfNcNXKYuWxaQVOl24UlzF2r3024'],
  modalSections: [
  {
    title: 'Vat 69',
    description: 'Argentina',
    role: 'Composed, produced, mixed.',
    videos: [{ muxId: 'bwp00SHIXyUrTWuMiHfNcNXKYuWxaQVOl24UlzF2r3024' }]
  }]

},
{
  title: 'Clight',
  subtitle: 'AR',
  imgSrc: 'https://image.mux.com/wMMIpxZ701PJT9xg6902MoMR023KKcfubmfauVC2za01yU4/thumbnail.webp?time=2',
  category: ['Advertising'],
  muxIds: ['wMMIpxZ701PJT9xg6902MoMR023KKcfubmfauVC2za01yU4'],
  modalSections: [
  {
    title: 'Clight',
    description: 'Argentina',
    role: 'Composed, produced, mixed.',
    videos: [{ muxId: 'wMMIpxZ701PJT9xg6902MoMR023KKcfubmfauVC2za01yU4' }]
  }]

},
{
  title: 'KitKat',
  subtitle: 'AR',
  imgSrc: '/assets/images/KitKat-1784076545868.png',
  category: ['Advertising'],
  muxIds: ['y11PMvfcxrI201mmlq5pVziIYBGJKk1vnpr725e5TipM'],
  modalSections: [
  {
    title: 'KitKat',
    description: 'Argentina',
    role: 'Composed, produced, mixed.',
    videos: [{ muxId: 'y11PMvfcxrI201mmlq5pVziIYBGJKk1vnpr725e5TipM' }]
  }]

},
{
  title: 'Chase',
  subtitle: 'US',
  imgSrc: 'https://image.mux.com/IX01gCBvlnPV6xmlAltmN8oN3hnUkoi5XxpAr01fC61EM/thumbnail.webp?time=23.5',
  category: ['Advertising'],
  muxIds: ['IX01gCBvlnPV6xmlAltmN8oN3hnUkoi5XxpAr01fC61EM'],
  modalSections: [
  {
    title: 'Chase',
    description: 'United States',
    role: 'Composed, produced, mixed.',
    videos: [{ muxId: 'IX01gCBvlnPV6xmlAltmN8oN3hnUkoi5XxpAr01fC61EM' }]
  }]

},
{
  title: 'Caser Seguros',
  subtitle: 'ES',
  imgSrc: 'https://image.mux.com/DzMnsNx54J6r3PSxwxIw5fseP0059XkM6PppE3025HHyc/thumbnail.webp?time=10.5',
  imgScale: 1.19,
  category: ['Advertising'],
  muxIds: ['DzMnsNx54J6r3PSxwxIw5fseP0059XkM6PppE3025HHyc'],
  modalSections: [
  {
    title: 'Caser Seguros',
    description: 'Spain',
    role: 'Composed, produced, mixed.',
    videos: [{ muxId: 'DzMnsNx54J6r3PSxwxIw5fseP0059XkM6PppE3025HHyc' }]
  }]

},
{
  title: 'PedidosYa',
  subtitle: 'AR',
  imgSrc: '/assets/images/Pedidos_ya-1784076543551.jpeg',
  category: ['Advertising'],
  muxIds: ['lr9ueWLZIHeKtw4rL4z2xbBnQ01AH00yUQiexBZyqdph4'],
  modalSections: [
  {
    title: 'PedidosYa',
    description: 'Argentina',
    role: 'Composed, produced, mixed.',
    videos: [{ muxId: 'lr9ueWLZIHeKtw4rL4z2xbBnQ01AH00yUQiexBZyqdph4' }]
  }]

},
{
  title: 'Fly with Pacha, into the Aerocene',
  year: '2024',
  subtitle: 'Dir. Tomás Saraceno & Maxi Laina',
  imgSrc: "/assets/images/Fly_with_Pacha__into_the_aerocene-1784141340820.png?v=2",
  imgScale: 1.32,
  category: ['Films'],
  muxIds: [
  'k4czhoBKIDvZI9z00yPbI5iN3OOoUxuEZ2R7H8Lrfsg4',
  '9jqfR02xttyv7asr02DL00cbFJqKxQX0100C49fPmfe6N7fk',
  '1NK1vERRmkcAG302fdVAeM8OFOx3lYDOtVo0100ev00B0001Y',
  'f00xvFE1OQls85t3RGqwijAXULeig01laMcYxcj75HbDU'],

  modalSections: [
  {
    title: 'Fly with Pacha, into the Aerocene',
    description: 'Directed by Tomás Saraceno & Maxi Laina',
    role: 'Original soundtrack. Composed, produced, mixed.',
    videos: [
    { muxId: 'k4czhoBKIDvZI9z00yPbI5iN3OOoUxuEZ2R7H8Lrfsg4' },
    { muxId: '9jqfR02xttyv7asr02DL00cbFJqKxQX0100C49fPmfe6N7fk' },
    { muxId: '1NK1vERRmkcAG302fdVAeM8OFOx3lYDOtVo0100ev00B0001Y' },
    { muxId: 'f00xvFE1OQls85t3RGqwijAXULeig01laMcYxcj75HbDU' }]

  }]

},
{
  title: 'Beyond the Ring',
  year: '2024',
  subtitle: 'Dir. Zon Chan',
  imgSrc: '/assets/images/Beyond_the_ring_1-1786563708149.png',
  category: ['Films'],
  muxIds: [
  '5ZuBwwtuJqM01ZW9IUN7nX01o102pflUDHRvPo9GSCxFPg',
  'kuI1MkFjAOsonI302DOPuKbw1zvgqTWqsT7iTlDSLQao',
  'rbDiGmBUUz66E1tmGFHTMpy4nWlcIupRHkaMC5100eLg',
  'mj2VJ4VALg016R1BKUa026rv7FOLUMLgIENokkYFWhp6E'],

  modalSections: [
  {
    title: 'Beyond the ring',
    description: 'Directed by Zon Chan',
    role: 'Original soundtrack. Composed, produced, mixed.',
    videos: [
    { muxId: '5ZuBwwtuJqM01ZW9IUN7nX01o102pflUDHRvPo9GSCxFPg' },
    { muxId: 'kuI1MkFjAOsonI302DOPuKbw1zvgqTWqsT7iTlDSLQao' },
    { muxId: 'rbDiGmBUUz66E1tmGFHTMpy4nWlcIupRHkaMC5100eLg' },
    { muxId: 'mj2VJ4VALg016R1BKUa026rv7FOLUMLgIENokkYFWhp6E' }]

  }]

},
{
  title: 'Todo adentro',
  year: '2024',
  subtitle: 'Dir. Justine Thieriot',
  imgSrc: '/assets/images/Todo_adentro_2-1786563710809.png',
  category: ['Films'],
  muxIds: [
  '1EixarP6WcdG9t7GDE01tTZXHnIwMhUd8k5bLioz3DNk',
  'Dh3ky01MlBgGBNeoYqNfqr4Hq01H014w2b6R01lG2lnHB01A',
  'U3Ad019iRRC02meTGhp02xV5u8XCNJlgGMhfkOcI00zyLJA',
  '6w4BLC901yTqTfnrEHIWSPV8X01zxyOwZB02USnUTeJIvw'],

  modalSections: [
  {
    title: 'Todo adentro',
    description: 'Directed by Justine Thieriot',
    role: 'Original soundtrack. Composed, produced, mixed.',
    videos: [
    { muxId: '1EixarP6WcdG9t7GDE01tTZXHnIwMhUd8k5bLioz3DNk' },
    { muxId: 'Dh3ky01MlBgGBNeoYqNfqr4Hq01H014w2b6R01lG2lnHB01A' },
    { muxId: 'U3Ad019iRRC02meTGhp02xV5u8XCNJlgGMhfkOcI00zyLJA' },
    { muxId: '6w4BLC901yTqTfnrEHIWSPV8X01zxyOwZB02USnUTeJIvw' }]

  }]

},
{
  title: 'Morbo y Mambo — Bao de Gong (live @ Buenos Aires)',
  imgSrc: '/assets/images/morbo_y_mambo_-_bao_de_gong-1784034938783.jpg',
  category: ['Music Bands'],
  muxIds: ['XdTb9LScFizFbCvfjTr8CBltPycZin00ihJ7IW7ArF100'],
  modalSections: [
  {
    title: 'Morbo y Mambo — Bao de Gong (live @ Buenos Aires)',
    description: '➔ Co-composed ● Electric guitar, synthesizer',
    videos: [{ muxId: 'XdTb9LScFizFbCvfjTr8CBltPycZin00ihJ7IW7ArF100' }]
  }]

},
{
  title: 'Mompox — Perfect Service',
  imgSrc: '/assets/images/mompox_-_perfect_service_2-1784034617742.jpg',
  category: ['Music Bands'],
  muxIds: ['s40000Dz8MQbJKQEC9BBd01oWA4l9bdkJv2RAWvQJNAXA00'],
  modalSections: [
  {
    title: 'Mompox — Perfect Service',
    description: '➔ Co-composed, co-produced ● Electric guitar, synthesizer, backing vocals',
    videos: [{ muxId: 's40000Dz8MQbJKQEC9BBd01oWA4l9bdkJv2RAWvQJNAXA00' }]
  }]

},
{
  title: 'Los Cerros — Corte de pelo',
  imgSrc: '/assets/images/Los_Cerros_-_Cuchillito_MODIFICADA-1786658108407.png',
  category: ['Music Bands'],
  muxIds: ['inSJuE56w9sp02OmO1aZoB100z99xzkEk6xz01eBQaDg00w'],
  modalSections: [
  {
    title: 'Los Cerros — Corte de pelo',
    description: '➔ Co-composed, produced ● Acoustic guitar, keyboards, percussion, drum programming',
    videos: [{ muxId: 'inSJuE56w9sp02OmO1aZoB100z99xzkEk6xz01eBQaDg00w' }]
  }]

},
{
  title: 'Cysalde — Crépitements nocturnes part 1 & 2',
  imgSrc: '/assets/images/Airbrush-image-extender-1784054512355.jpeg',
  imgFit: 'contain',
  category: ['Music Bands'],
  muxIds: ['gn3mruSyfpLR5bcDqUazk9ze5UpweSzGxsvoJE6agYY'],
  modalSections: [
  {
    title: 'Cysalde — Crépitements nocturnes part 1 & 2',
    description: '➔ Co-produced ● Acoustic & electric guitar, bass guitar, keyboards, backing vocals, percussion, drum programming',
    videos: [{ muxId: 'gn3mruSyfpLR5bcDqUazk9ze5UpweSzGxsvoJE6agYY' }]
  }]

},
{
  title: 'Trijaus — Full time killer',
  imgSrc: '/assets/images/Trijaus_-_Full_time_killer-1784034614744.jpeg',
  category: ['Music Bands'],
  muxIds: ['Py7S4mmhwIwMLIl00lJaIzanGj2LwvRE2bRiIMp8mEaQ'],
  modalSections: [
  {
    title: 'Trijaus — Full time killer',
    description: '➔ Co-composed ● Co-produced ● Acoustic guitar, electric guitar, backing vocals, percussion',
    videos: [{ muxId: 'Py7S4mmhwIwMLIl00lJaIzanGj2LwvRE2bRiIMp8mEaQ' }]
  }]

},
{
  title: 'Morbo y Mambo — Rogers Nelson',
  imgSrc: "/assets/images/Morbo_y_mambo_-_Rogers_Nelson-1784141340933.png?v=2",
  category: ['Music Bands'],
  muxIds: ['OlkyYrL7NvHwJL9agzfPM8HJmQ9YXSyZCUZQnWxiR02Q'],
  modalSections: [
  {
    title: 'Morbo y Mambo — Rogers Nelson',
    description: '➔ Co-composed ● Electric guitar',
    videos: [{ muxId: 'OlkyYrL7NvHwJL9agzfPM8HJmQ9YXSyZCUZQnWxiR02Q' }]
  }]

},
{
  title: 'Mompox — Love is breaking me',
  imgSrc: "/assets/images/Mompox_-_love_is_breaking_me-1784141352799.png?v=2",
  category: ['Music Bands'],
  muxIds: ['8Ak02T75J01m3PfGJ4iD7JkzvKpAE7vumdG8FKn8fdTLE'],
  modalSections: [
  {
    title: 'Mompox — Love is breaking me',
    description: '➔ Co-composed ● Electric guitar, backing vocals',
    videos: [{ muxId: '8Ak02T75J01m3PfGJ4iD7JkzvKpAE7vumdG8FKn8fdTLE' }]
  }]

},
{
  title: 'Los Cerros — La Fe (live @ MAMBA, Buenos Aires)',
  imgSrc: '/assets/images/Los_Cerros_-_La_Fe_2-1784034614202.jpg',
  imgScale: 1.24,
  category: ['Music Bands'],
  muxIds: ['FtaMB26aSCtdnl1E5lsYb8BCpdNLfKTdmKupJcZSmro'],
  modalSections: [
  {
    title: 'Los Cerros — La Fe (live @ MAMBA, Buenos Aires)',
    description: '➔ Co-composed, produced ● Bass guitar',
    videos: [{ muxId: 'FtaMB26aSCtdnl1E5lsYb8BCpdNLfKTdmKupJcZSmro' }]
  }]

},
{
  title: 'Ignacio de Andrés & Ana Carucci — Live @ Rota Festival (Spain, 2022)',
  imgSrc: "/assets/images/Ignacio_de_Andres_y_Ana_Carucci-1784141367963.png?v=2",
  category: ['Music Bands'],
  muxIds: ['Zf01Zu700kSODIRMH27BM3S00sPFokjgUx4nv7JRFRJL02U'],
  modalSections: [
  {
    title: 'Ignacio de Andrés & Ana Carucci — Live @ Rota Festival (Spain, 2022)',
    description: '➔ Co-composed ● Synths, FX, field recordings',
    videos: [{ muxId: 'Zf01Zu700kSODIRMH27BM3S00sPFokjgUx4nv7JRFRJL02U' }]
  }]

},
{
  title: 'Leandro Erlich — Weightless',
  imgSrc: "/assets/images/leandro_erlich_-_weighless-1784141568838.jpg?v=2",
  category: ['Exhibitions'],
  muxIds: [
  'YHi2fhNRypYYGpD7HyFRKkKvQQwtk1f3Ri79R6Vsbtg',
  'MYvmXlRfV00G02c7tOG1w300IZgkT79FJuAsCkSnRrXKHU'],

  modalSections: [
  {
    title: 'Leandro Erlich — Weightless',
    role: 'Music and sound supervision.',
    description: 'Video by Nicolás Dardano\nMusic and sound design by Sound of ruins\nKunstmuseum, 2024\nWolfsburg, DE',
    videos: [
    { muxId: 'YHi2fhNRypYYGpD7HyFRKkKvQQwtk1f3Ri79R6Vsbtg' },
    { muxId: 'MYvmXlRfV00G02c7tOG1w300IZgkT79FJuAsCkSnRrXKHU' }],

    images: [
    { src: '/assets/images/Kunstmuseum-Wolfsburg-Art4All-04_2025-cMarek-Kruszewski-30-1024x683-1784039934588.jpg', alt: 'Leandro Erlich — Weightless exhibition at Kunstmuseum Wolfsburg, installation view 1' },
    { src: '/assets/images/241009_KMW_by_Kruszewski_1277-900x600-1784039934357.jpg', alt: 'Leandro Erlich — Weightless exhibition at Kunstmuseum Wolfsburg, installation view 2' }]

  }]

},
{
  title: 'Malala Lekander — Oceánica',
  imgSrc: "/assets/images/Oceanica_4-1784140708327.png?v=2",
  category: ['Exhibitions'],
  muxIds: ['C02O01tHkrqquGbniR2SK8yygBbXNNDUzWoj02214ZCykk'],
  modalSections: [
  {
    title: 'Malala Lekander — Oceánica',
    description: 'Video by Nicolás Dardano',
    role: 'Music and sound design.',
    videos: [{ muxId: 'C02O01tHkrqquGbniR2SK8yygBbXNNDUzWoj02214ZCykk' }]
  }]

},
{
  title: 'Martina Quesada — Like earth in heaven',
  imgSrc: "/assets/images/like_earth_in_heaven_3-1784141586239.jpg?v=2",
  category: ['Exhibitions'],
  muxIds: ['GOx6Ip86Te01pzfysdTZcK00ypVw1YEtxqpK5NmhVeFbY'],
  modalSections: [
  {
    title: 'Martina Quesada — Like earth in heaven',
    description: 'Cecilia Brunson Projects, 2022\nLondon, UK',
    role: 'Sound design.',
    videos: [{ muxId: 'GOx6Ip86Te01pzfysdTZcK00ypVw1YEtxqpK5NmhVeFbY' }]
  }]

},
{
  title: 'Conectados',
  subtitle: 'Una mirada a la tecnología que nos acerca',
  imgSrc: "/assets/images/12-scaled-1784061271662.jpg",
  category: ['Exhibitions'],
  muxIds: [
  'hFa9cSDs9gGrLvcMibk3o01ZgBYG00fYx2QzTPiEVMYic',
  '4MVhxNCAdIw00YeXQCr00LKNLRpjCFpEtwsr3WXC9SUJo'],

  modalSections: [
  {
    title: 'Conectados. Una mirada a la tecnología que nos acerca',
    description: 'Fundación Telefónica Argentina, 2020\nBuenos Aires, AR',
    role: 'Music and sound design.',
    videos: [
    { muxId: 'hFa9cSDs9gGrLvcMibk3o01ZgBYG00fYx2QzTPiEVMYic' },
    { muxId: '4MVhxNCAdIw00YeXQCr00LKNLRpjCFpEtwsr3WXC9SUJo' }],

    images: [
    { src: '/assets/images/58870313_2092228344233006_6742729042719408128_n-1784039326527.jpg', alt: 'Conectados exhibition photo 1' },
    { src: '/assets/images/58377104_2092228070899700_1643013303561093120_n-1784039326517.jpg', alt: 'Conectados exhibition photo 2' }]

  }]

},
{
  title: 'Martina Quesada — Is nothing sacred?',
  imgSrc: '/assets/images/is_nothing_sacred-1784034615576.jpg',
  category: ['Exhibitions'],
  muxIds: ['2Q7T01hVW6nL6bo02rQxg6QIBYlWHog4IaUQtkrKocMWY'],
  modalSections: [
  {
    title: 'Martina Quesada — Is nothing sacred?',
    description: 'Galería Revolver, 2020\nBuenos Aires, AR',
    role: 'Music and sound design.',
    videos: [{ muxId: '2Q7T01hVW6nL6bo02rQxg6QIBYlWHog4IaUQtkrKocMWY' }],
    images: [
    { src: '/assets/images/Is_nothing_sacred_FLYER-1784039519143.png', alt: 'Is nothing sacred? — Exhibition flyer' },
    { src: '/assets/images/Is_nothing_sacred_1-1784039520531.png', alt: 'Is nothing sacred? — Exhibition photo 1' },
    { src: '/assets/images/Is_nothing_sacred_3-1784039520487.png', alt: 'Is nothing sacred? — Exhibition photo 2' }],

    unifiedGrid: true
  }]

}];


const countryNames: Record<string, string> = {
  AR: 'Argentina',
  MX: 'Mexico',
  US: 'United States',
  CAN: 'Canada',
  ES: 'Spain',
  BR: 'Brazil',
  CO: 'Colombia',
  PE: 'Peru',
  CL: 'Chile'
};

const CATEGORIES: Category[] = ['All', 'Advertising', 'Films', 'Music Bands', 'Exhibitions'];

// ─── Project Modal ────────────────────────────────────────────────────────────

interface ProjectModalProps {
  project: Project;
  onClose: () => void;
}

function ProjectModal({ project, onClose }: ProjectModalProps) {
  const categoryLabel = project.category[0] ?? '';
  const [visible, setVisible] = useState(false);

  // Trigger enter animation on mount
  useEffect(() => {
    const raf = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(raf);
  }, []);

  // Animated close: fade out then call onClose
  const handleClose = useCallback(() => {
    setVisible(false);
    setTimeout(onClose, 250);
  }, [onClose]);

  // Lock body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  // Close on Escape key
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') handleClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [handleClose]);

  const sections = project.modalSections ?? [];

  return (
    <div
      className="fixed inset-0 z-[100] flex items-start justify-center overflow-y-auto"
      style={{
        background: `rgba(0, 0, 0, ${visible ? 0.75 : 0})`,
        transition: 'background 0.25s ease'
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) handleClose();
      }}>

      <div
        className="relative w-full max-w-5xl my-8 mx-4 md:my-16 md:mx-8 p-6 md:p-12"
        style={{
          background: 'rgba(243, 244, 239)',
          color: 'rgb(17, 17, 17)',
          opacity: visible ? 1 : 0,
          transform: visible ? 'scale(1)' : 'scale(0.95)',
          transition: 'opacity 0.25s ease, transform 0.25s ease'
        }}>

        {/* Close button */}
        <button
          type="button"
          aria-label="Close"
          onClick={handleClose}
          className="absolute top-4 right-4 text-[12px] uppercase tracking-[0.18em] opacity-70 hover:opacity-100 transition-opacity">
          ✕ Close
        </button>

        {/* Category label */}
        <div className="mb-8 pr-16">
          {categoryLabel &&
          <div className="text-[11px] uppercase tracking-[0.22em] opacity-50 mb-3">
              Work — {categoryLabel === 'Music Bands' ? 'Music Bands' : categoryLabel === 'Films' ? 'Films' : categoryLabel === 'Exhibitions' ? 'Exhibitions' : 'Advertising'}
            </div>
          }
        </div>

        {/* Sections */}
        <div className="space-y-14">
          {sections.map((section, sIdx) =>
          <div key={sIdx}>
              {/* Section title */}
              {section.title &&
            <h3
              className="mb-1"
              style={{
                fontFamily: 'Fraunces, Georgia, serif',
                fontSize: 'clamp(1.4rem, 3vw, 2.2rem)',
                lineHeight: 1.1,
                fontWeight: 600
              }}>
                  {section.title}
                </h3>
            }

              {/* Section description — for Advertising & Films, show before role */}
              {(categoryLabel === 'Advertising' || categoryLabel === 'Films') && section.description &&
            <p
              className={`text-[13px] opacity-60 leading-relaxed whitespace-pre-line mb-1`}>
                  {section.description}
                </p>
            }

              {/* Section role */}
            {section.role &&
            <p className={`text-[13px] opacity-60 leading-relaxed italic ${categoryLabel === 'Advertising' || categoryLabel === 'Films' ? 'mb-6' : 'mb-1'}`}>
➔ {section.role}
              </p>
            }

              {/* Section description — for other categories (Music Bands, Exhibitions), show after role */}
              {categoryLabel !== 'Advertising' && categoryLabel !== 'Films' && section.description &&
            <p
              className={`text-[13px] opacity-60 leading-relaxed whitespace-pre-line mb-6`}>
                  {categoryLabel === 'Music Bands' && section.description.startsWith('➔') ?
              <><span>➔ </span><em>{section.description.slice(2)}</em></> :
              section.description}
                </p>
            }

              {/* Videos grid */}
              {!section.unifiedGrid &&
            <div
              className={`grid gap-4 ${
              section.videos.length > 1 ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1'}`
              }>
{section.videos.map((video, vIdx) =>
              <div key={vIdx} className="relative w-full overflow-hidden bg-black" style={{ aspectRatio: '16 / 9' }}>
                    <VideoPlayer
                  poster={`https://image.mux.com/${video.muxId}/thumbnail.webp?time=0`}
                  playbackId={video.muxId} />
                
                  </div>
              )}
              </div>
            }

              {/* Unified 2×2 grid (videos + images together) */}
              {section.unifiedGrid &&
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {section.videos.map((video, vIdx) =>
              <div key={`v-${vIdx}`} className="relative w-full overflow-hidden bg-black" style={{ aspectRatio: '16 / 9' }}>
                      <VideoPlayer
                  poster={`https://image.mux.com/${video.muxId}/thumbnail.webp?time=0`}
                  playbackId={video.muxId} />
                
                    </div>
              )}
                  {section.images && section.images.map((img, iIdx) =>
              <div key={`i-${iIdx}`} className="relative w-full overflow-hidden bg-black" style={{ aspectRatio: '16 / 9' }}>
                      {/* eslint-disable-next-line @next/next/no-img-element */}
                      <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover" />
                
                    </div>
              )}
                </div>
            }

              {/* Images grid */}
              {!section.unifiedGrid && section.images && section.images.length > 0 &&
            <div
              className={`grid gap-4 mt-4 ${
              section.images.length > 1 ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1'}`
              }>
{section.images.map((img, iIdx) =>
              <div key={iIdx} className="relative w-full overflow-hidden bg-black" style={{ aspectRatio: '16 / 9' }}>
                      {/* eslint-disable-next-line @next/next/no-img-element */}
                      <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover" />
                
                    </div>
              )}
                </div>
            }
            </div>
          )}

          {/* Fallback: no modalSections defined */}
          {sections.length === 0 &&
          <div className="relative w-full overflow-hidden bg-black" style={{ aspectRatio: '16 / 9' }}>
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
              src={project.imgSrc}
              alt={project.title}
              className="absolute inset-0 h-full w-full object-cover" />
            
            </div>
          }
        </div>
      </div>
    </div>);

}

// ─── Video Player ─────────────────────────────────────────────────────────────

interface VideoPlayerProps {
  poster: string;
  playbackId: string;
}

function VideoPlayer({ playbackId }: VideoPlayerProps) {
  return (
    <div className="absolute inset-0 w-full h-full bg-black">
      <iframe
        className="absolute inset-0 h-full w-full"
        src={`https://player.mux.com/${playbackId}?preload=metadata`}
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen"
        allowFullScreen
        title="Mux video player" />
      
    </div>);

}

// ─── BounceWebP ───────────────────────────────────────────────────────────────
// Plays an animated WebP in ping-pong (bounce) mode: forward → backward → forward…
function BounceWebP({ src, alt, className }: {src: string;alt: string;className?: string;}) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [useNativeImg, setUseNativeImg] = useState(false);

  useEffect(() => {
    // Detect if ImageDecoder is unavailable (iOS Safari, iOS Chrome, iOS Brave)
    if (typeof (window as any).ImageDecoder === 'undefined') {
      setUseNativeImg(true);
      return;
    }

    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    let rafId: number;
    let cancelled = false;

    async function run() {
      try {
        const response = await fetch(src);
        const blob = await response.blob();
        const decoder = new (window as any).ImageDecoder({
          data: blob.stream(),
          type: 'image/webp',
          preferAnimation: true
        });

        await decoder.completed;

        const track = decoder.tracks.selectedTrack;
        const frameCount: number = track.frameCount;

        if (!frameCount || frameCount < 2) {
          const result = await decoder.decode({ frameIndex: 0 });
          canvas!.width = result.image.displayWidth;
          canvas!.height = result.image.displayHeight;
          ctx!.drawImage(result.image, 0, 0);
          result.image.close();
          return;
        }

        const frames: {bitmap: ImageBitmap;duration: number;}[] = [];
        for (let i = 0; i < frameCount; i++) {
          const result = await decoder.decode({ frameIndex: i });
          const bitmap = await createImageBitmap(result.image);
          const durationUs = result.image.duration;
          const durationMs = durationUs && durationUs > 0 ? durationUs / 1000 : 80;
          frames.push({ bitmap, duration: durationMs });
          result.image.close();
        }

        if (cancelled || frames.length === 0) return;

        canvas!.width = frames[0].bitmap.width;
        canvas!.height = frames[0].bitmap.height;

        let currentFrame = 0;
        let direction = 1;
        let lastTime: number | null = null;
        let elapsed = 0;

        ctx!.drawImage(frames[0].bitmap, 0, 0);

        function animate(timestamp: number) {
          if (cancelled) return;

          if (lastTime === null) {
            lastTime = timestamp;
            rafId = requestAnimationFrame(animate);
            return;
          }

          const delta = timestamp - lastTime;
          lastTime = timestamp;
          elapsed += delta;

          const frameDuration = frames[currentFrame].duration;

          if (elapsed >= frameDuration) {
            elapsed -= frameDuration;

            currentFrame += direction;

            if (currentFrame >= frames.length) {
              currentFrame = frames.length - 2;
              direction = -1;
            } else if (currentFrame < 0) {
              currentFrame = 1;
              direction = 1;
            }

            ctx!.clearRect(0, 0, canvas!.width, canvas!.height);
            ctx!.drawImage(frames[currentFrame].bitmap, 0, 0);
          }

          rafId = requestAnimationFrame(animate);
        }

        rafId = requestAnimationFrame(animate);
      } catch (err) {
        console.warn('BounceWebP fallback to native img:', err);
        setUseNativeImg(true);
      }
    }

    run();

    return () => {
      cancelled = true;
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [src]);

  if (useNativeImg) {
    return (
      <div ref={containerRef} className={`${className ?? ''} block md:inline-block`} style={{}}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={src}
          alt={alt}
          style={{ width: '100%', height: 'auto', display: 'block' }} />
        
      </div>);

  }

  return (
    <div ref={containerRef} className={`${className ?? ''} block md:inline-block`} style={{}}>
      <canvas ref={canvasRef} style={{ width: '100%', height: 'auto', display: 'block' }} aria-label={alt} />
    </div>);

}

// ─── Main Page ────────────────────────────────────────────────────────────────

export default function HomePage() {
  const [activeCategory, setActiveCategory] = useState<Category>('All');
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const filteredProjects =
  activeCategory === 'All' ?
  projects :
  projects.filter((p) => p.category.includes(activeCategory));

  return (
    <div
      className="min-h-screen w-full overflow-x-hidden"
      style={{ background: 'rgba(243, 244, 239)', color: '#111', fontFamily: "'Inter', sans-serif" }}>

      {/* ── Header ── */}
      <header
        className="fixed top-0 left-0 right-0 z-50 px-8 md:px-16 pt-7 pb-4 flex items-center justify-between border-b border-black/10 backdrop-blur-md"
        style={{ background: 'rgba(243, 244, 239, 0.85)' }}>
        <div
          style={{ fontFamily: "'Fraunces', Georgia, serif", fontWeight: 600 }}
          className="text-base md:text-xl italic">
          <a
            href="#"
            onClick={(e) => {e.preventDefault();window.scrollTo({ top: 0, behavior: 'smooth' });}}
            className="hover:opacity-60 transition-opacity"
            style={{ textDecoration: 'none', color: 'inherit' }}>
            Ignacio de Andrés
          </a>
        </div>

        {/* Desktop nav */}
        <nav className="hidden md:flex gap-8 text-[13px] uppercase tracking-[0.18em]">
          <a href="#work" className="hover:opacity-60 transition-opacity">Work</a>
          <a href="#about" className="hover:opacity-60 transition-opacity">About</a>
          <a href="#contact" className="hover:opacity-60 transition-opacity">Contact</a>
        </nav>

        {/* Mobile hamburger */}
        <button
          type="button"
          aria-label="Toggle menu"
          className="md:hidden flex flex-col justify-center items-center gap-[5px] w-8 h-8"
          onClick={() => setMenuOpen((prev) => !prev)}>
          <span className={`block w-5 h-[1.5px] bg-current transition-all duration-200 ${menuOpen ? 'rotate-45 translate-y-[6.5px]' : ''}`} />
          <span className={`block w-5 h-[1.5px] bg-current transition-all duration-200 ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-5 h-[1.5px] bg-current transition-all duration-200 ${menuOpen ? '-rotate-45 -translate-y-[6.5px]' : ''}`} />
        </button>
      </header>

      {/* Mobile dropdown menu */}
      {menuOpen &&
      <div
        className="md:hidden fixed top-[60px] left-0 right-0 z-40 px-8 py-6 flex flex-col gap-5 border-b border-black/10"
        style={{ background: 'rgba(243, 244, 239, 0.97)' }}>
          <a
          href="#work"
          className="text-[13px] uppercase tracking-[0.18em] hover:opacity-60 transition-opacity"
          onClick={() => setMenuOpen(false)}>
            Work
          </a>
          <a
          href="#about"
          className="text-[13px] uppercase tracking-[0.18em] hover:opacity-60 transition-opacity"
          onClick={() => setMenuOpen(false)}>
            About
          </a>
          <a
          href="#contact"
          className="text-[13px] uppercase tracking-[0.18em] hover:opacity-60 transition-opacity"
          onClick={() => setMenuOpen(false)}>
            Contact
          </a>
        </div>
      }

      {/* ── Hero ── */}
      <section className="w-full px-8 md:px-16 pt-0 md:pt-60 pb-0 md:pb-60 min-h-[70vh] md:min-h-0 flex justify-center items-center overflow-hidden">
        <BounceWebP
          src="/assets/images/STG_vessel__1_-1784046283770.webp"
          alt="Animated visual"
          className="w-full md:w-auto" />
        
      </section>

      {/* ── Work Section ── */}
      <section id="work" className="px-8 md:px-16 pt-48 md:pt-36 pb-60 md:border-t border-black/10">
        {/* Header row */}
        <div className="flex flex-wrap items-baseline justify-between gap-6 mb-10">
          <h2 className="text-[13px] uppercase tracking-[0.18em] opacity-60">Selected Work</h2>
          <span className="text-[13px] tabular-nums opacity-60">{projects.length} projects</span>
        </div>

        {/* Filter buttons */}
        <div className="flex flex-wrap gap-2 mb-10 border-b border-black/10 pb-6">
          {CATEGORIES.map((cat) =>
          <button
            key={cat}
            onClick={() => setActiveCategory(cat)}
            className={`text-[12px] uppercase tracking-[0.18em] px-4 py-2 rounded-full border transition-colors ${
            activeCategory === cat ?
            'bg-black text-white border-black' : 'border-black/20 hover:border-black/60'}`
            }>
              {cat}
            </button>
          )}
        </div>

        {/* Projects grid */}
        <ul className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-10">
          {filteredProjects.map((project, idx) =>
          <li key={`${project.title}-${idx}`}>
              <button
              type="button"
              className="group w-full text-left"
              aria-label={`Open ${project.title}`}
              onClick={() => setSelectedProject(project)}>

                {/* Thumbnail */}
                <div
                className="relative w-full overflow-hidden bg-black/90"
                style={{ aspectRatio: '16 / 9' }}>
                  {/* eslint-disable-next-line @next/next/no-img-element */}
                  <img
                  src={project.imgSrc}
                  alt={project.title}
                  loading={idx < 6 ? 'eager' : 'lazy'}
                  decoding="async"
                  {...idx < 6 ? { fetchPriority: 'high' as const } : {}}
                  className={`absolute inset-0 h-full w-full transition-transform duration-500 group-hover:scale-[1.03] ${
                  project.imgFit === 'contain' ? 'object-contain' : 'object-cover'}`
                  }
                  style={project.imgScale ? { transform: `scale(${project.imgScale})` } : undefined} />
                
                </div>

                {/* Title row */}
                <div className="mt-3 flex items-baseline justify-between gap-3">
                  <span
                  className="transition-all group-hover:italic"
                  style={{
                    fontFamily: "'Fraunces', Georgia, serif",
                    fontSize: '1.125rem',
                    lineHeight: 1.15
                  }}>
                    {(project.category.includes('Music Bands') || project.category.includes('Exhibitions')) && project.title.includes(' — ') ?
                  project.title.split(' — ')[0] :
                  project.title}
                  </span>
                  {project.year && !project.category.includes('Films') &&
                <span className="shrink-0 text-[11px] tabular-nums opacity-60">
                      {project.year}
                    </span>
                }
                </div>

                {/* Subtitle */}
                {(project.category.includes('Music Bands') || project.category.includes('Exhibitions')) && project.title.includes(' — ') ?
              <div className="mt-1 text-[13px] opacity-60">
                    {project.title.split(' — ').slice(1).join(' — ')}
                  </div> :
              project.subtitle &&
              <div className="mt-1 text-[13px] opacity-60">
                    {project.category.includes('Advertising') && countryNames[project.subtitle] ?
                countryNames[project.subtitle] :
                project.subtitle}
                  </div>
              }
              </button>
            </li>
          )}
        </ul>
      </section>

      {/* Spacer */}
      <div className="h-[120vh] md:h-[65vh]" aria-hidden="true" />

      {/* ── About Section ── */}
      <section
        id="about"
        className="px-8 md:px-16 py-12 md:py-16 grid grid-cols-12 gap-6 border-t border-black/10"
        style={{ scrollMarginTop: '72px' }}>
        <p className="col-span-12 md:col-span-2 text-[13px] uppercase tracking-[0.18em] opacity-60">
          Bio
        </p>
        <div className="col-span-12 md:col-span-10">
          <p
            style={{
              fontFamily: "'Fraunces', Georgia, serif",
              fontSize: 'clamp(0.925rem, 1.3vw, 1.325rem)',
              lineHeight: 1.6
            }}>
            My relationship with music began through playing, writing, and producing. I started as a guitarist and bassist in different bands and musical projects, developing my craft through years of recording, performing, and collaborating with other artists. That path took me from recording studios to tours across Europe, the United States, and Latin America, performing at festivals including <a href="https://www.vivelatino.com.mx/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}><em>Vive Latino</em></a> (Mexico), <a href="https://sxsw.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}><em>South by Southwest</em></a> (USA), <a href="https://musicwins.com.ar/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}><em>Music Wins</em></a> (Argentina), and <a href="https://recbeatfestival.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}><em>Festival Rec-Beat</em></a> (Brazil).
            <br /><br />
            Over time, I became increasingly interested in the relationship between sound and image, and in the way music could shape the emotional dimension of a story. This curiosity led me to study Film Directing, expanding my understanding of narrative and opening a new creative path into music for audiovisual media.
            <br /><br />
            For more than twenty years, I have composed music for films, commercials, and art and cultural exhibitions. Eight years ago, my work expanded beyond composition when I began supervising music and sound projects at <a href="https://www.tritonsonido.com/en" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}><em>Tritón Sonido</em></a>, an Argentina-based sound post-production studio specializing in film, television, and immersive experiences. Since then, I have combined creative work with project supervision, collaborating with multidisciplinary teams to help transform ideas into carefully crafted audiovisual pieces.
            <br /><br />
            Whether composing or supervising a project, my focus is always on finding the sound that best serves the story.
          </p>
        </div>
      </section>

      {/* Spacer */}
      <div className="h-[150vh] md:h-[130vh]" aria-hidden="true" />

      {/* ── Footer / Contact ── */}
      <footer
        id="contact"
        className="px-8 md:px-16 pt-40 pb-24 border-t border-black/10 min-h-screen flex flex-col justify-center">
        <p className="text-[13px] uppercase tracking-[0.18em] opacity-60 mb-12">Contact</p>
        <p
          style={{
            fontFamily: "'Fraunces', Georgia, serif",
            fontSize: 'clamp(1.5rem, 3vw, 2.5rem)',
            lineHeight: 1.1
          }}
          className="italic opacity-70 mb-4">
          Say hello →
        </p>
        <a
          href="mailto:nachodeandres@gmail.com"
          style={{
            fontFamily: "'Fraunces', Georgia, serif",
            fontSize: 'clamp(2.5rem, 7vw, 6rem)',
            lineHeight: 1
          }}
          className="italic block hover:opacity-60 transition-opacity break-all">
          nachodeandres@gmail.com
        </a>
        <div className="mt-24 pt-8 border-t border-black/10">
          <a
            href="https://www.linkedin.com/in/ndea/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[13px] uppercase tracking-[0.18em] hover:opacity-60 transition-opacity inline-flex items-center gap-2">
            LinkedIn ↗
          </a>
        </div>
      </footer>

      {/* ── Project Modal ── */}
      {selectedProject &&
      <ProjectModal
        project={selectedProject}
        onClose={() => setSelectedProject(null)} />

      }
    </div>);

}